module.exports = __webpack_public_path__ + "media/images/cplook/careerplug_white_small-93e12db1d65e94bf8728ef863e5359a7.png";